const initData = {

  brand: {
    contain: '',
    exclude: ''
  },
  cate: {
    contain: '',
    exclude: ''
  },
  goods: {
    contain: '',
    exclude: ''
  }

}

export default {

  // goods: initData.goods,
  // brand: initData.brand,
  // category: initData.category,
  sectionGoods: initData

}



// WEBPACK FOOTER //
// ./src/store/section-product/state.js